<template>
  <div>
    <div>
      <h1 class="text-center">Campaign Management</h1>
      <p class="text-center text-muted">
        Manage referral campaigns and rewards
      </p>
      <div>
        <ListReferralCampaign />
      </div>
    </div>
  </div>
</template>

<script>
import ListReferralCampaign from "./ListReferralCampaign.vue";
export default {
  components: {
    ListReferralCampaign,
  },
};
</script>
